const EC2_CONTEXT_PREFIX = "ec2Context:";

function getEc2ContextKey(user) {
  if (!user || !user.organization || !user.username) return null;
  const org = String(user.organization || "").toLowerCase().trim();
  const uname = String(user.username || "").toLowerCase().trim();
  return `${EC2_CONTEXT_PREFIX}${org}#${uname}`;
}

module.exports = {
    getUser: function() {
        const user = sessionStorage.getItem('user');
        if (user === 'undefined' || !user) {
            return null;
        } else {
            return JSON.parse(user);
        }
    },

    getToken: function() {
        return sessionStorage.getItem('token');
    },

    setUserSession: function(user, token) {
        sessionStorage.setItem('user', JSON.stringify(user));
        sessionStorage.setItem('token', token);
    },

    resetUserSession: function() {
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('token');

        // Clear any EC2 context keys
        Object.keys(sessionStorage)
        .filter((k) => k.startsWith(EC2_CONTEXT_PREFIX))
        .forEach((k) => sessionStorage.removeItem(k));
    },

    getOrganization: function() {
        const user = this.getUser();  
        console.log("user: ", user)
        if (user && user.organization) {
            return user.organization.toLowerCase();  
        }
        return null;  
    },

    getEc2Context: function () {
        const user = this.getUser();
        const key = getEc2ContextKey(user);
        if (!key) return null;

        const val = sessionStorage.getItem(key);
        if (!val) return null;

        try {
        return JSON.parse(val);
        } catch {
        return null;
        }
    },

    // 👉 NEW: set EC2 context for current user
    setEc2Context: function (context) {
        const user = this.getUser();
        const key = getEc2ContextKey(user);
        if (!key) return;

        const payload = {
        instanceId: context?.instanceId || "",
        region: context?.region || "us-east-1",
        instanceName: context?.instanceName || "",
        };

        sessionStorage.setItem(key, JSON.stringify(payload));
    },
};
